import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../core';
import { periodicidadeMensal } from '../../../../shared';
import { ClienteAnaliseMercadoProjecaoSearch } from '../cliente-analise-mercado-projecao-search';
import { ClienteAnaliseMercadoProjecaoSave } from '../cliente-analise-mercado-projecao-save';
import { ClienteAnaliseMercadoProjecaoUpdateStatus } from '../cliente-analise-mercado-projecao-update-status';

@Injectable({
    providedIn: 'root'
})
export class ClienteAnaliseMercadoProjecaoHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/clienteanalisemercado/projecao`;
    }


    /** Realiza a pesquisa das projeções dos clientes nas análises de mercados */
    search(idCliente: number, mes: number, ano: number, statusProjetados: number[], idsEtapasNegociacoesProjecoes: number[]): Observable<ClienteAnaliseMercadoProjecaoSearch[]> {
        let params = new HttpParams();
        // Cliente
        if (idCliente) {
            params = params.append('idCliente', idCliente.toString());
        }
        // Periodicidade
        params = params.append('periodicidade', periodicidadeMensal.id.toString());
        // Mês
        if (mes) {
            params = params.append('mes', mes.toString());
        }
        // Ano
        if (ano) {
            params = params.append('ano', ano.toString());
        }
        // Status Projetados
        statusProjetados?.forEach(statusProjetado => {
            params = params.append('statusProjetado', statusProjetado.toString());
        });
        // Etapas Negociações Projeções
        idsEtapasNegociacoesProjecoes?.forEach(idEtapaNegociacaoProjecao => {
            params = params.append('idEtapaNegociacaoProjecao', idEtapaNegociacaoProjecao.toString());
        });

        return this.customHttp.get<ClienteAnaliseMercadoProjecaoSearch[]>(this.pathApi, {params});
    }

    /** Salva as projeções de vendas do cliente na análises de mercados */
    save(entitySave: ClienteAnaliseMercadoProjecaoSave): Observable<ClienteAnaliseMercadoProjecaoSave> {
        return this.customHttp.post<ClienteAnaliseMercadoProjecaoSave>(this.pathApi, entitySave);
    }

    /** Atualiza o status projetado das projeções mensais do cliente **/
    updateStatusProjecoesCliente(entityUpdate: ClienteAnaliseMercadoProjecaoUpdateStatus): Observable<ClienteAnaliseMercadoProjecaoSearch> {
        return this.customHttp.put<ClienteAnaliseMercadoProjecaoSearch>(`${this.pathApi}/status`, entityUpdate);
    }
}
